import { get } from "../services/APIHandler";
import { AppSessionStorage } from "../enums/appSessionStorage";

class ConfigService {
  readonly appSessionStorage = AppSessionStorage;

  getTenantConfigData = () => {
    return new Promise((resolve) => {
      get("../../GetContainerizationInfo", (error, response) => {
        if (response) {
          resolve({
            Containerized: response.data?.isContainerized,
            TenantName: response.data?.tenantName,
          });
        } else {
          console.log(error);
          resolve({
            Containerized: false,
            TenantName: "",
          });
        }
      });
    });
  };

  readTaskPaneConfig = () => {
    return new Promise((resolve, reject) => {
      this.getTenantConfigData().then((response: any) => {
        console.log("Is Containerized: " + response.Containerized + ", Tenant Name: " + response.TenantName);
        let tenantConfigPath = "";
        if (response.Containerized && response.TenantName) {
          tenantConfigPath = "../../" + response.TenantName + "/Outlookjsv2Addin/ConfigFiles/taskpaneConfig.json";
        } else {
          tenantConfigPath = "../../taskpaneConfig.json";
        }

        get(tenantConfigPath, (error, response) => {
          if (error) {
            reject(error);
          } else {
            resolve(response);
          }
        });
      });
    });
  };

  getTaskpaneConfigData = () => {
    return new Promise((resolve, reject) => {
      this.readTaskPaneConfig()
        .then((response: any) => {
          this.setApiUrl(response.data.apiUrl);
          this.setIcmUrl(response.data.icmUrl);
          this.setPluginDomain(response.data.pluginDomain);
          this.setUserAPITokenURl(response.data.userApiTokenUrl);
          this.setSignOutUrl(response.data.signOutUrl);
          this.setSearchMasterDataContractType(response.data.searchMasterDataContractType);
          this.setSearchMasterDataSysID(response.data.searchMasterDataSysID);
          this.setVisibleAttrsConfigMasterDataContractType(response.data.visibleAttrsConfigMasterDataContractType);
          this.setVisibleAttrsConfigMasterDataSysID(response.data.visibleAttrsConfigMasterDataSysID);
          resolve(response.data);
          this.setTenantId(response.data.msGraphTenantId);
          this.setClientId(response.data.msGraphClientId);
          this.setRedirectUri(response.data.msGraphRedirectUri);
          this.setCategory(response.data.categoryToSet);
          this.setMsGraphAuthUrl(response.data.msGraphAuthUrl);
          this.setMsGraphFlag(response.data.EnableMSGraph);
          this.setOauthFlag(response.data.OauthEnabled);
          this.setMsGraphUrl(response.data.msGraphUrl);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  /**
   * Get API endpoint
   */
  getApiUrl(): string {
    return sessionStorage.getItem(this.appSessionStorage.API_URL);
  }

  /**
   * Get Icm url
   */
  getIcmUrl(): string {
    return sessionStorage.getItem(this.appSessionStorage.ICM_URL);
  }

  /**
   * Get Plugin Domain
   */
  getPluginDomain(): string {
    return sessionStorage.getItem(this.appSessionStorage.PLUGIN_DOMAIN);
  }

  /**
   * Set API Url
   * @param apiUrl
   */
  setApiUrl(apiUrl: string): void {
    sessionStorage.setItem(this.appSessionStorage.API_URL, apiUrl);
  }

  /**
   * Set ICM URL
   * @param icmUrl
   */
  setIcmUrl(icmUrl: string): void {
    sessionStorage.setItem(this.appSessionStorage.ICM_URL, icmUrl);
  }

  /**
   * Set Plugin Domain
   * @param pluginDomain
   */
  setPluginDomain(pluginDomain: string): void {
    sessionStorage.setItem(this.appSessionStorage.PLUGIN_DOMAIN, pluginDomain);
  }

  /**
   * Set User API Token URl
   * @param setUserAPITokenURl
   */
  setUserAPITokenURl(setUserAPITokenURl: string): void {
    sessionStorage.setItem(this.appSessionStorage.USER_API_TOKEN, setUserAPITokenURl);
  }

  /**
   *
   * Get User API Token URl
   * @param
   */
  getUserAPITokenURl(): string {
    return sessionStorage.getItem(this.appSessionStorage.USER_API_TOKEN);
  }

  /**
   * Set Sign Out Url
   * @param setSignOutUrl
   */
  setSignOutUrl(setSignOutUrl: string): void {
    sessionStorage.setItem(this.appSessionStorage.SIGN_OUT_URL, setSignOutUrl);
  }

  /**
   *
   * Get Sign Out Url
   * @param
   */
  getSignOutUrl(): string {
    return sessionStorage.getItem(this.appSessionStorage.SIGN_OUT_URL);
  }

  /**
   * Set Search Master Data Contract Type
   * @param setSearchMasterDataContractType
   */
  setSearchMasterDataContractType(setSearchMasterDataContractType: string): void {
    sessionStorage.setItem(this.appSessionStorage.SEARCH_MASTER_DATA_CONTRACT_TYPE, setSearchMasterDataContractType);
  }

  /**
   * Get Search Master Data Contract Type
   * @param
   */
  getSearchMasterDataContractType(): string {
    return sessionStorage.getItem(this.appSessionStorage.SEARCH_MASTER_DATA_CONTRACT_TYPE);
  }

  /**
   * Set Search Master Data Sys ID
   * @param setSearchMasterDataSysID
   */
  setSearchMasterDataSysID(setSearchMasterDataSysID: string): void {
    sessionStorage.setItem(this.appSessionStorage.SEARCH_MASTER_DATA_SYS_ID, setSearchMasterDataSysID);
  }

  /**
   * Get Search Master Data Sys ID
   * @param
   */
  getSearchMasterDataSysID(): string {
    return sessionStorage.getItem(this.appSessionStorage.SEARCH_MASTER_DATA_SYS_ID);
  }

  /**
   * Set visible attrs config master data contract type
   * @param setVisibleAttrsConfigMasterDataContractType
   */
  setVisibleAttrsConfigMasterDataContractType(setVisibleAttrsConfigMasterDataContractType: number): void {
    sessionStorage.setItem(
      // visibleAttrsConfigMasterDataContractType
      this.appSessionStorage.VISIBLE_ATTRS_CONFIG_MASTER_DATA_CONTRACT_TYPE,
      setVisibleAttrsConfigMasterDataContractType.toString()
    );
  }

  /**
   * Set Visible Attrs Config Master Data Sys ID
   * @param setVisibleAttrsConfigMasterDataSysID
   */
  setVisibleAttrsConfigMasterDataSysID(setVisibleAttrsConfigMasterDataSysID: number): void {
    sessionStorage.setItem(
      this.appSessionStorage.VISIBLE_ATTRS_CONFIG_MASTER_DATA_SYS_ID,
      setVisibleAttrsConfigMasterDataSysID.toString()
    );
  }

  /**
   * Get Visible Attributes Data Sys ID
   * @param
   */
  getVisibleAttrsConfigMasterDataSysID(): string {
    return sessionStorage.getItem(this.appSessionStorage.VISIBLE_ATTRS_CONFIG_MASTER_DATA_SYS_ID);
  }

  /**
   * Get Visible Attributes Data Contract Type
   * @param
   */
  getVisibleAttrsConfigMasterDataContractType(): string {
    return sessionStorage.getItem(this.appSessionStorage.VISIBLE_ATTRS_CONFIG_MASTER_DATA_CONTRACT_TYPE);
  }

  /**
   * Set Tenant Id
   * @param tenantId
   */
  setTenantId(tenantId: string): void {
    sessionStorage.setItem(this.appSessionStorage.TENANT_ID, tenantId);
  }

  /**
   * Get Tenant Id
   */
  getTenantId(): string {
    return sessionStorage.getItem(this.appSessionStorage.TENANT_ID);
  }

  /**
   * Set Client Id
   * @param clientId
   */
  setClientId(clientId: string): void {
    sessionStorage.setItem(this.appSessionStorage.CLIENT_ID, clientId);
  }

  /**
   * Get Client Id
   */
  getClientId(): string {
    return sessionStorage.getItem(this.appSessionStorage.CLIENT_ID);
  }

  /**
   * Set Redirect URI
   * @param redirectUri
   */
  setRedirectUri(redirectUri: string): void {
    sessionStorage.setItem(this.appSessionStorage.REDIRECT_URI, redirectUri);
  }

  /**
   * Get Redirect URI
   */
  getRedirectUri(): string {
    return sessionStorage.getItem(this.appSessionStorage.REDIRECT_URI);
  }

  /**
   * Set Category
   * @param category
   */
  setCategory(redirectUri: string): void {
    sessionStorage.setItem(this.appSessionStorage.CATEGORY_TO_SET, redirectUri);
  }

  /**
   * Get Category
   */
  getCategory(): string {
    return sessionStorage.getItem(this.appSessionStorage.CATEGORY_TO_SET);
  }

  /**
   * Set MS Graph Auth URL
   * @param url
   */
  setMsGraphAuthUrl(url: string): void {
    sessionStorage.setItem(this.appSessionStorage.MS_GRAPH_AUTH_URL, url);
  }

  /**
   * Get MS Graph Auth URL
   */
  getMsGraphAuthUrl(): string {
    return sessionStorage.getItem(this.appSessionStorage.MS_GRAPH_AUTH_URL);
  }

  /**
   * Set MS Graph Flag
   * @param flag
   */
  setMsGraphFlag(flag: string): void {
    sessionStorage.setItem(this.appSessionStorage.MS_GRAPH_FLAG, flag);
  }

  /**
   * Get MS Graph Flag
   */
  getMsGraphFlag(): string {
    return sessionStorage.getItem(this.appSessionStorage.MS_GRAPH_FLAG);
  }

  /**
   * Set OAuth Flag
   * @param flag
   */
  setOauthFlag(flag: string): void {
    sessionStorage.setItem(this.appSessionStorage.OAUTH_ENABLED, flag);
  }

  /**
   * Get OAuth Flag
   */
  getOauthFlag(): string {
    return sessionStorage.getItem(this.appSessionStorage.OAUTH_ENABLED);
  }

  /**
   * Set MS Graph URL
   * @param url
   */
  setMsGraphUrl(url: string): void {
    sessionStorage.setItem(this.appSessionStorage.MS_GRAPH_URL, url);
  }

  /**
   * Get MS Graph URL
   */
  getMsGraphUrl(): string {
    return sessionStorage.getItem(this.appSessionStorage.MS_GRAPH_URL);
  }
}

export default ConfigService;
